// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { GetAllInstrumentConfigurationsResponse } from '@digitalasset/utility-operator-api-ts-client';
import { getInstIdentifierKey } from './getInstConfigKey';

export const getInstConfigMap = (data?: GetAllInstrumentConfigurationsResponse) => {
  const configMap = new Set<string>();
  if (!data?.instrumentConfigurations) {
    return configMap;
  }
  data.instrumentConfigurations.forEach((i) => {
    const key = getInstIdentifierKey(
      i.payload.defaultIdentifier.id,
      i.payload.defaultIdentifier.source,
    );
    configMap.add(key);
  });
  return configMap;
};
